import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1xgqui4-0' })`
    display: flex;
    align-items: center;
    padding: ${size(0.25)} ${size(1)};
    background-color: var(--c-bg-alt);
    border-radius: ${(props) => props.theme.size.borderRadius};
    font-size: ${(props) => props.theme.font.size.xsmall};
    font-weight: var(--font-weight-bold);
    color: var(--c-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.15em;
`;

export const Label = styled.div.withConfig({ componentId: 'sc-1xgqui4-1' })``;

export const Action = styled(ButtonReset).withConfig({ componentId: 'sc-1xgqui4-2' })`
    flex-shrink: 0;
    margin-left: ${size(0.25)};
    color: var(--c-link);
    font-size: 1.2em;
    isolation: isolate;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-color: var(--c-bg-alt);
        opacity: 0;
        border-radius: 50%;
        z-index: -1;
        transition: opacity 200ms ease;
    }

    &::after {
        content: "";
        position: absolute;
        inset: ${size(-0.5)} ${size(-1)};
    }

    &:hover {
        &::before {
            opacity: 1;
        }
    }
`;
